import styled from 'styled-components'

export const ContainerMenuBurger = styled.div`
  display: grid;
  grid-template-columns: 1fr 7fr 2fr;
  grid-template-areas: 'logo menu burguer';
`

export const MenuMobile = styled.ul`
  /* Menu - Desktop */
  position: relative;
  width: 380px;
  height: 635px;
  background-color: ${props => props.theme.colors.white};
  top: 0;
  box-sizing: border-box;
  padding: 0 0;
  z-index: 16;


  li:nth-child(4) {
    border-top: 1px solid #E5E5E5;
  }
`


export const TopTextMenu = styled.p`
  font-size: 20px;
  line-height: 24px;
  color: ${props => props.theme.colors.secondary};
  font-family: ${props => props.theme.font};
  padding: 12px 0;
  font-weight: 900;
`
